import { featureFlagKeySchema } from "@redotech/feature-flags-model/schema";
import * as z from "zod";

export const getUserFeatureFlag = {
  name: "getUserFeatureFlag" as const,
  input: z.object({ email: z.string().email(), flagKey: featureFlagKeySchema }),
  output: z.object({ value: z.boolean() }),
};
